import React, { useRef } from 'react';
const SolutionCard = ({ data, Header }) => {
    const videoRef = useRef();
    return (
        <a href={data.slug}>
            {data.media.bg_video ? (
                <div className="section_solution"
                    onMouseEnter={() => (videoRef.current.play())}
                    onMouseLeave={() => (videoRef.current.pause())}
                >
                    <div className="bg_image" style={{ backgroundImage: `url(${data.media.bg_image})`, backgroundSize: "cover" }}></div>

                    <div className="bg_video">
                        <video preload="none" muted loop
                        height="100%"
                            ref={videoRef}
                            poster={data.media.bg_image}
                        >
                            <source src={data.media.bg_video} type="video/mp4" />
                                Your browser does not support the video tag.
                    </video>
                    </div>
                    <Header title={data.name} tag="h3"></Header>
                    <p>{data.description}</p>
                </div>
            ) : (
                    <div className="section_solution"
                    ><div className="bg_image" style={{ backgroundImage: `url(${data.media.bg_image})`, backgroundSize: "cover" }}></div>

                        <Header title={data.name} tag="h3"></Header>
                        <p>{data.description}</p>
                    </div>
                )}
        </a>
    );
}

export default SolutionCard;